/**
 * @fileoverview Taskflow - Layout Header component React interface for Mobile
 * @author Qiwen Luo (qluo@yext.com)
 */

import * as styles from '/ui/components/taskflow/layoutHeaderMobile/layoutHeaderMobile.module.scss';
import * as Types from '/ui/components/taskflow/models';

import {ButtonProps} from '/ui/components/button/button';
import {LayoutHeader} from '/ui/components/taskflow/layoutHeader/layoutHeader';
import {Tab} from '/ui/components/tabs/tab';
import {Tabs} from '/ui/components/tabs/tabs';

/**
 * @param {{
 *   icon: (React.ReactNode|undefined),
 *   title: string,
 *   description: string,
 *   resourceLink: (Types.ResourceLinkType|undefined),
 *   headerCTAs: (!Array<React.ReactNode>|undefined),
 *   contents: !Array<!Types.ContentType>,
 * }} props
 * @return {React.ReactElement}
 */
export function LayoutHeaderMobile({
  icon,
  title,
  description,
  resourceLink,
  headerCTAs,
  contents,
}) {
  return (
    <div className={styles.container}>
      <LayoutHeader
        icon={icon}
        title={title}
        description={description}
        resourceLink={resourceLink}
        headerCTAs={headerCTAs}
        isMobile={true}
      />
      <Tabs tabLabelStyle={styles.tabLabel} onTabChange={() => {}}>
        {
          contents.map((content, index) => {
            return (
              <Tab key={index} label={content.contentHeader} id={content.contentHeader}>
                <div className={styles.contentBody}>{content.contentBody}</div>
              </Tab>
            );
          })
        }
      </Tabs>
    </div>
  );
}
